import { useMemo } from 'react'
import { useTranslations } from '~/src/hooks/useTranslations'

interface Props {
  error: string,
  prefix?: string,
}

const ErrorLabel = ({ error, prefix = '' }: Props) => {
  const { t } = useTranslations()

  const _getLabel = useMemo<string>(() => {
    if (/^[A-Z]+(?:_[A-Z]+)*$/.test(error)) {
      return t(`api.errors.${error}`)
    }

    return error
  }, [ t, error ])

  if (!_getLabel) {
    return null
  }

  return (
    <>
      {prefix}{_getLabel}
    </>
  )
}

export default ErrorLabel
